import { useLocalStorage } from '@/hooks/useStorage';

import { getAreaCodeApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';

export default () => {
  //当前区号
  const [currentAreaCode, setCurrentAreaCode] = useLocalStorage({
    key: 'currentAreaCode',
    defaultValue: null,
  });
  //获取区号列表
  const { data: areaCode } = useReq(getAreaCodeApi, {
    onSuccess(
      data: Array<{
        areaCode: string;
        isDefault: number;
        countryName: string;
        areaName: string;
        areaCodeName: string;
      }>
    ) {
      if (data?.length <= 0) return;
      const currentPick = data?.find((item) => +item?.areaCode === +currentAreaCode?.areaCode);
      // 当前选中在列表中不存在或者压根没选则走进判断
      if (!currentAreaCode || !currentPick) {
        const defaultAreaCode = data?.find((item) => +item?.isDefault === 1);
        setCurrentAreaCode(defaultAreaCode ?? data[0]);
      }
    },
  });

  return {
    areaCode,
    currentAreaCode,
    setCurrentAreaCode,
  };
};
